export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            有想看的电影？欢迎投稿推荐，我们第一时间收录
          </p>
        </div>

        <div className="bg-background-50 rounded-lg border border-background-200/60 p-6 md:p-8">
          <form
            data-readdy-form
            id="contact-form"
            action="https://readdy.ai/api/form/d9mb7l0bdkpk99j7g900"
            method="POST"
            encType="application/x-www-form-urlencoded"
            onSubmit={async (e) => {
              e.preventDefault();
              const form = e.currentTarget;

              const honeypot = form.querySelector<HTMLInputElement>('[name="phone_alt"]');
              if (honeypot && honeypot.value.trim() !== '') {
                const successEl = document.getElementById('contact-success');
                if (successEl) successEl.style.display = 'block';
                const errorEl = document.getElementById('contact-error');
                if (errorEl) errorEl.style.display = 'none';
                return;
              }

              const formData = new FormData(form);

              try {
                const res = await fetch(form.action, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                  body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                });
                const responseText = await res.text();
                let parsed: Record<string, unknown> = {};
                try {
                  parsed = JSON.parse(responseText);
                } catch {
                  // ignore parse error
                }

                if (
                  res.ok &&
                  parsed &&
                  typeof parsed === 'object' &&
                  (parsed as Record<string, unknown>).code === 'OK'
                ) {
                  const successEl = document.getElementById('contact-success');
                  if (successEl) successEl.style.display = 'block';
                  const errorEl = document.getElementById('contact-error');
                  if (errorEl) errorEl.style.display = 'none';
                  form.reset();
                } else {
                  const msg =
                    (parsed as Record<string, unknown>)?.meta &&
                    typeof (parsed as Record<string, unknown>).meta === 'object'
                      ? ((parsed as Record<string, unknown>).meta as Record<string, string>).message || ''
                      : '';
                  const errorEl = document.getElementById('contact-error');
                  if (errorEl) errorEl.style.display = 'block';
                  const successEl = document.getElementById('contact-success');
                  if (successEl) successEl.style.display = 'none';
                  if (errorEl && msg) errorEl.textContent = msg;
                }
              } catch {
                const errorEl = document.getElementById('contact-error');
                if (errorEl) errorEl.style.display = 'block';
                const successEl = document.getElementById('contact-success');
                if (successEl) successEl.style.display = 'none';
              }
            }}
            className="space-y-4"
          >
            <div className="anti-spam-field">
              <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
            </div>

            <div>
              <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1">
                你的昵称
              </label>
              <input
                type="text"
                id="contact-name"
                name="name"
                required
                className="w-full px-4 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors"
                placeholder="请输入昵称"
              />
            </div>

            <div>
              <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1">
                电子邮箱
              </label>
              <input
                type="email"
                id="contact-email"
                name="email"
                required
                className="w-full px-4 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors"
                placeholder="请输入你的邮箱"
              />
            </div>

            <div>
              <label htmlFor="contact-movie" className="block text-sm font-medium text-foreground-700 mb-1">
                推荐影片名称
              </label>
              <input
                type="text"
                id="contact-movie"
                name="movie_name"
                required
                className="w-full px-4 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors"
                placeholder="你想看的电影叫什么？"
              />
            </div>

            <div>
              <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1">
                留言内容（选填）
              </label>
              <textarea
                id="contact-message"
                name="message"
                maxLength={500}
                rows={3}
                className="w-full px-4 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors resize-none"
                placeholder="有什么想对我们说的？"
              ></textarea>
              <p className="text-xs text-foreground-400 mt-1">最多500字</p>
            </div>

            <button
              type="submit"
              className="w-full py-3 rounded-md bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              提交推荐
            </button>

            <div id="contact-success" className="hidden p-3 rounded-md bg-accent-50 text-accent-800 text-sm text-center">
              推荐已提交，感谢你的支持！我们会尽快收录该影片。
            </div>
            <div id="contact-error" className="hidden p-3 rounded-md bg-primary-50 text-primary-700 text-sm text-center">
              提交失败，请稍后重试。
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}